import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({ title, description, keywords, image, url }) => {
  const siteTitle = title ? `${title} — Nneji Chidi Ben` : 'Nneji Chidi Ben — Lead Software Engineer';
  const siteDescription = description || "Selected works and engineering practice of Nneji Chidi Ben. Lead Software Engineer specializing in high-throughput backend architecture, resilient web platforms, and precision interfaces.";
  const siteImage = image || "https://chidiportfolio.netlify.app/og.png";
  const siteUrl = url || "https://chidiportfolio.netlify.app/";

  return (
    <Helmet>
      {/* Standard metadata tags */}
      <title>{siteTitle}</title>
      <meta name='description' content={siteDescription} />
      {keywords && <meta name='keywords' content={keywords} />}
      <link rel="canonical" href={siteUrl} />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content="website" />
      <meta property="og:url" content={siteUrl} />
      <meta property="og:title" content={siteTitle} />
      <meta property="og:description" content={siteDescription} />
      <meta property="og:image" content={siteImage} />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={siteUrl} />
      <meta name="twitter:title" content={siteTitle} />
      <meta name="twitter:description" content={siteDescription} />
      <meta name="twitter:image" content={siteImage} />

      {/* JSON-LD Structured Data */}
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@graph": [
            {
              "@type": "Person",
              "@id": `${siteUrl}#person`,
              "name": "Nneji Chidi Ben",
              "alternateName": "Chidi Ben",
              "jobTitle": "Lead Software Engineer",
              "email": "mailto:chidiisking7@gmail.com",
              "url": siteUrl,
              "image": siteImage,
              "sameAs": [
                "https://github.com/Chidi09",
                "https://linkedin.com/in/chidi-ben",
                "https://twitter.com/Benimaru177",
                "https://wa.me/2347019008948"
              ],
              "address": {
                "@type": "PostalAddress",
                "addressLocality": "Lagos",
                "addressCountry": "NG"
              },
              "alumniOf": {
                "@type": "CollegeOrUniversity",
                "name": "Crawford University"
              },
              "knowsAbout": [
                "Rust",
                "Tokio",
                "Hyper",
                "Golang",
                "Next.js",
                "TypeScript",
                "Dart",
                "Flutter",
                "Systems Architecture",
                "Compilers",
                "WebAssembly",
                "Docker"
              ]
            },
            {
              "@type": "WebSite",
              "@id": `${siteUrl}#website`,
              "url": siteUrl,
              "name": "Nneji Chidi Ben — Portfolio & Engineering Practice",
              "description": siteDescription,
              "publisher": {
                "@id": `${siteUrl}#person`
              }
            }
          ]
        })}
      </script>
    </Helmet>
  );
};

export default SEO;
